var map = {
	"./CreateTagIcon.svg": 815,
	"./Hyderabad.png": 816,
	"./Key.png": 817,
	"./No-data-page.svg": 818,
	"./Path.png": 819,
	"./Path@1.5x.svg": 820,
	"./Path@2x.png": 821,
	"./Path@3x.png": 822,
	"./PlusImg.png": 823,
	"./PlusImg1.png": 824,
	"./Quad3rick.png": 825,
	"./Star.png": 826,
	"./align.svg": 827,
	"./awards1.png": 828,
	"./awards2.png": 829,
	"./bg-img.png": 830,
	"./big_notification_bell.svg": 831,
	"./blog-img.png": 832,
	"./blog-img2.png": 833,
	"./blog-img3.png": 834,
	"./c6rrect.png": 835,
	"./camera.svg": 836,
	"./captain-ic.png": 837,
	"./card-img.png": 838,
	"./card-img.svg": 839,
	"./chatadd.png": 840,
	"./chatadd.svg": 841,
	"./chatadd@2x.png": 842,
	"./chatadd@3x.png": 843,
	"./chatmenu.png": 844,
	"./checkcyan.svg": 845,
	"./checked-w.svg": 846,
	"./checked.svg": 847,
	"./circle-shape-png-hd-background-view-all-images.png": 848,
	"./circular-tick.png": 849,
	"./clock-ic.png": 850,
	"./coins-refpay.svg": 851,
	"./coins.png": 852,
	"./coming-soon-img.png": 853,
	"./comment.svg": 854,
	"./congrats-bg.png": 855,
	"./connection-bg.png": 856,
	"./cross.png": 857,
	"./crystall-ball-trophy.png": 858,
	"./default-team-img.svg": 859,
	"./default-user-old.png": 860,
	"./default-user.png": 861,
	"./default_Pan_Image.png": 862,
	"./demoprofile.jpeg": 863,
	"./emojinew.svg": 864,
	"./eye-cancel-dark-green.png": 865,
	"./eye-cancel-dark.png": 866,
	"./eye-cancel.png": 867,
	"./eye-dark.png": 868,
	"./eye.png": 869,
	"./eye.svg": 870,
	"./fan-challenge-bg.png": 871,
	"./fan-challenge-bg2.png": 872,
	"./flag_default.png": 873,
	"./full-logo.png": 874,
	"./golden-star.png": 875,
	"./gray-bg-img.png": 876,
	"./green-logo.png": 877,
	"./groups.svg": 878,
	"./header-bg-full.png": 879,
	"./header-bg-white-full.png": 880,
	"./header-bg-white.png": 881,
	"./header-bg.png": 882,
	"./icon-coin.svg": 883,
	"./joinicon.svg": 884,
	"./keyboard-btn.jpeg": 885,
	"./keyboard_icon_white.svg": 886,
	"./keyboard_icon_white1.svg": 887,
	"./lb-banner.png": 888,
	"./like.svg": 889,
	"./loader.gif": 890,
	"./location_pin.png": 891,
	"./logo-black.png": 892,
	"./logo-new.png": 893,
	"./logo-purple.png": 894,
	"./logo.png": 895,
	"./lose.png": 896,
	"./lose.svg": 897,
	"./mark_zuckerberg.png": 898,
	"./medals.png": 899,
	"./membership-bg.png": 900,
	"./menuicon.svg": 901,
	"./message.png": 902,
	"./mice.svg": 903,
	"./minus-img.png": 904,
	"./modal-bg-img.png": 905,
	"./pause.png": 906,
	"./payment-method.png": 907,
	"./play.svg": 908,
	"./playbutton.png": 909,
	"./player-img.png": 910,
	"./plusround.svg": 911,
	"./profile-cross.svg": 912,
	"./redadd.png": 913,
	"./redcross.svg": 914,
	"./reflive.svg": 915,
	"./refpay-header-bg.png": 916,
	"./refpay.svg": 917,
	"./refpredictor.svg": 918,
	"./refsocail-header-bg.png": 919,
	"./refsocial.svg": 920,
	"./remove-ic@1x.svg": 921,
	"./repost.svg": 412,
	"./rpl-cup.png": 922,
	"./save.svg": 923,
	"./section1-bg.png": 924,
	"./send.png": 925,
	"./send.svg": 926,
	"./send@2x.png": 927,
	"./send@3x.png": 928,
	"./share.svg": 929,
	"./singer-img.png": 930,
	"./singer-img2.png": 931,
	"./smile.svg": 932,
	"./sponsered-img.png": 933,
	"./sweden.png": 934,
	"./team-flag.png": 935,
	"./team-logo-shadow.png": 936,
	"./team-logo.png": 937,
	"./team1.png": 938,
	"./team2.png": 939,
	"./text.svg": 940,
	"./thumbs-up.png": 941,
	"./tick.png": 942,
	"./tie.png": 943,
	"./tie.svg": 944,
	"./trophy-ic.png": 945,
	"./uncheckcyan.svg": 946,
	"./user-img2.png": 947,
	"./user-img3.png": 948,
	"./user-oldie.svg": 949,
	"./user.svg": 950,
	"./vinfotech-logo.png": 951,
	"./vissel.png": 952,
	"./wallet-oldie.svg": 953,
	"./wallet.png": 954,
	"./wallet.svg": 955,
	"./whatsapp.png": 956,
	"./whistle-shape-bg.png": 957,
	"./whistle-shape-bg_oldie.png": 958,
	"./win.png": 959,
	"./win.svg": 960,
	"./winning-ic.png": 961
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 814;